import { render, staticRenderFns } from "./componente-prefixopagto.vue?vue&type=template&id=4ca70b1b"
import script from "./componente-prefixopagto.vue?vue&type=script&lang=js"
export * from "./componente-prefixopagto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports